import { combineReducers } from "redux";
import register from "./register.reducer";

const reducer = combineReducers({
  register,
});

export default reducer;
